import { useFeatureGate } from '@/src/services/Statsig/useFeatureGate'
import * as Statsig from '../../statsig'
import { withCardGate } from '@/src/experiences/card-accounts/withCardGate'
import { CardDeliveryBarSkeleton } from './Skeleton'
import { CardDeliveryBarHighnote } from './Highnote'
import { CardDeliveryBarPlatform } from './Platform'
import { DesignSystem } from '@/src/design-system'

export const CardDeliveryBar = withCardGate(function ({
  newestApplication,
  firstCardFetchFinished,
  refetchApplicationStatus,
}) {
  DesignSystem.ScreenWideReload.useReloadListener(async () => {
    await refetchApplicationStatus()
  })

  const isCardInTransitUiEnabledFeatureGate = useFeatureGate(
    Statsig.FeatureGate.CardInTransitUiEnabled,
  )
  const isCardInTransitUiEnabled = isCardInTransitUiEnabledFeatureGate.featureGate?.value

  if (isCardInTransitUiEnabledFeatureGate.loadingStatus !== 'Ready' || !firstCardFetchFinished) {
    return <CardDeliveryBarSkeleton />
  }

  if (!isCardInTransitUiEnabled || !newestApplication) {
    return null
  }

  switch (newestApplication.platform) {
    case 'HIGHNOTE':
      return <CardDeliveryBarHighnote />
    case 'LOANPRO':
      return <CardDeliveryBarPlatform />
    default:
      return null
  }
})
